<script>
  import Left from "common/icons/Left";
  import Right from "common/icons/Right";
  import addLeadingZero from "common/utils/addLeadingZero.js";
  import Cell from "./Cell";

  export let strings = {
    shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    month: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    shortMonth: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    todayLabel: "Today",
  };
  export let firstDay = 1;
  export let date = new Date();
  export let events = {};
  export let selected = [];
  export let map = function map(date) {
    var output = {
      day: date.getDate(),
      hintTop: undefined,
      hintBottom: undefined,
      url: null,
    };
    var today = new Date();
    var event = events[dateToString(date)];

    if (eqDates(date, today)) {
      output.hintTop = strings.todayLabel;
      // output.html += `<div class="kalendar--cell-hint__top">
      //   ${strings.todayLabel}
      //   </div>`;
    } else if (date.getDate() === 1) {
      output.hintTop = strings.shortMonth[date.getMonth()];
      // output.html += `<div class="kalendar--cell-hint__top">${
      //   strings.shortMonth[date.getMonth()]
      // }</div>`;
    }
    if (event) {
      output.url = event.url;
      // output.html += `<a class="kalendar--cell-date" href="${
      //   event.url
      // }">${date.getDate()}</a>`;
      if (event.bottomHint) {
        output.hintBottom = event.bottomHint;
        // output.html += `<div class="kalendar--cell-hint__bottom">${event.bottomHint}</div>`;
      }
    } else {
      // output.html += `<div class="kalendar--cell-date">${date.getDate()}</div>`;
    }
    return output;
  };

  export let mapClassName = function mapClassName(events, date) {
    var classes = [0, 6].indexOf(date.getDay()) !== -1 ? "__weekend" : "";
    var event = events[dateToString(date)];
    var isSelected = event && selected.indexOf(dateToString(date)) !== -1;
    var today = new Date();
    classes += eqDates(date, today) ? " __today" : "";
    if (event) {
      classes += " __active";
    }
    if (isSelected) {
      classes += " __selected";
    }
    return classes;
  };

  function getDay(date) {
    var day = date.getDay();
    var offset = firstDay;
    if (offset > 0) {
      day -= offset;
      if (day < 0) {
        day += 7;
      }
    }
    return day;
  }

  function eqDates(d1, d2) {
    return d1.setHours(0, 0, 0, 0) === d2.setHours(0, 0, 0, 0);
  }

  function dateToString(d) {
    d = new Date(d);
    return (
      d.getFullYear() +
      "-" +
      addLeadingZero(d.getMonth() + 1) +
      "-" +
      addLeadingZero(d.getDate())
    );
  }

  function renderNavigationDate(opts) {
    return strings.month[date.getMonth()] + " " + date.getFullYear();
  }
  function renderDayName(initialDay) {
    var day = initialDay;
    day += firstDay;
    while (day >= 7) {
      day -= 7;
    }
    return strings.shortDays[day];
  }

  function renderMatrix(events, date) {
    var d = new Date(date);
    d.setDate(1);
    var month = d.getMonth(); // Zore based

    var rows = [];

    var row = [];

    var prev = new Date(d);
    prev.setDate(0);
    prev.setDate(prev.getDate() - getDay(d));

    for (var i = 0; i < getDay(d); i++) {
      prev.setDate(prev.getDate() + 1);
      row.push({
        classes: "__prev " + mapClassName(events, prev),
        ...map(prev),
      });
    }

    while (d.getMonth() === month) {
      row.push({
        classes: mapClassName(events, d),
        ...map(d),
      });
      if (getDay(d) % 7 === 6) {
        rows.push(row);
        row = [];
      }

      d.setDate(d.getDate() + 1);
    }

    if (getDay(d) !== 0) {
      for (var i = getDay(d); i < 7; i++) {
        row.push({
          classes: "__next " + mapClassName(events, d),
          ...map(d),
        });
        d.setDate(d.getDate() + 1);
      }
    }

    if (row.length > 0) {
      rows.push(row);
    }

    return rows;
  }
  function handlePrev(e) {
    let newDate = new Date(date);
    var prevMonth = newDate.getMonth() - 1;
    newDate.setMonth(prevMonth, 1);
    date = newDate;
  }

  function handleNext(e) {
    let newDate = new Date(date);
    var nextMonth = newDate.getMonth() + 1;
    newDate.setMonth(nextMonth, 1);
    date = newDate;
  }
</script>

<style>
  .kalendar {
    font-family: MainBrandFont, "Helvetica Neue", system-ui, -apple-system,
      BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell",
      "Fira Sans", "Droid Sans", sans-serif;
  }
  .kalendar--nav {
    display: flex;
    padding-bottom: 10px;
    align-items: center;
  }

  .kalendar--nav-action {
    height: 40px;
    margin: 0 1px;
    padding: 0 15px;
    display: flex;
    flex: 0 0 calc(100% / 7);
    justify-content: center;
    align-items: center;
    border: none;
    background-color: transparent;
    font-size: 24px;
    color: #08c;
    color: var(--main-link-foreground-color, #08c);
    text-align: center;
  }

  :global(.kalendar--nav-action path) {
    fill: #08c;
    fill: var(--main-link-foreground-color, #08c);
  }

  .kalendar--nav-action:hover {
    color: inherit;
  }

  .kalendar--nav-month {
    flex: 1 0 auto;
    text-align: center;
    font-size: 19px;
    font-weight: 500;
    font-family: MainBrandFont, "Helvetica Neue", system-ui, -apple-system,
      BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell",
      "Fira Sans", "Droid Sans", sans-serif;
    text-transform: uppercase;
    opacity: 0.75;
  }

  .kalendar--row {
    display: flex;
  }

  .kalendar--cell-heading {
    display: flex;
    flex: 1 0 1%;
    height: 38px;
    margin: 1px;
    padding: 5px 0;
    align-items: center;
    justify-content: space-around;
    text-transform: uppercase;
    font-weight: 500;
    color: var(--main-label-foreground-color, #333);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
</style>

<div class="kalendar">
  <nav class="kalendar--nav mb-4">
    <button
      class="kalendar--nav-action"
      aria-label="left icon"
      on:click|preventDefault={handlePrev}>
      <Left width="25" height="25" />
    </button>
    <div class="kalendar--nav-month">
      {strings.month[date.getMonth()] + " " + date.getFullYear()}
    </div>
    <button
      class="kalendar--nav-action"
      aria-label="right icon"
      on:click|preventDefault={handleNext}>
      <Right width="25" height="25" />
    </button>
  </nav>
  <div class="grid -mx-6 -mb-6 px-6 pb-6 bg-mainInnerCardBackground">
    <div class="kalendar--row __day-name">
      {#each strings.shortDays as days, index}
        <div class="kalendar--cell-heading">{renderDayName(index)}</div>
      {/each}
    </div>

    {#each renderMatrix(events, date) as week}
      <div class="kalendar--row __week">
        <!--  -->
        {#each week as day}
          <Cell {...day} />
        {/each}
      </div>
    {/each}
  </div>
</div>
